<template>
  <div class="free-nights-inputs">
    <!-- TITULO DO CAMPO DOS INPUTS -->
    <b-row>
      <b-col cols="11">
        <PmwHeading
          size="paragraph-60"
          weight="weight-normal"
          class="form--title"
        >
          Configuração de noites grátis
          <PmwParagraph class="form--subtitle" size="paragraph-40">
            Informe com que frequência de noites o hóspede terá direito a noites
            gratuitas.

            <PmwInfoTooltip width="316px">
              <template #content>
                As noites grátis são acumulativas. Ex: Se o mínimo de noites
                para ganhar uma noite grátis for 7 e o cliente selecionar 14
                noites, ele receberá 2 noites grátis.
              </template>
            </PmwInfoTooltip>
          </PmwParagraph>
        </PmwHeading>
      </b-col>

      <!-- ICONE DE FECHAR -->
      <b-col class="remove-col" cols="1">
        <button class="remove-col--btn" @click="$emit('closeInputs', $event)">
          <Icon icon="x-icon" />
        </button>
      </b-col>
    </b-row>

    <div class="form--row">
      <!-- INPUTS DE NOITES -->

      <!-- INPUT DE MINIMO DE NOITES -->
      <PmwFormInput
        v-model.number="fluctuationData.diariasNoitesGratis"
        :required="fluctuationData.utilizaNoitesGratis"
        :error="errors.includes('UtilizaNoitesGratis') || hasErrors"
        data-error="UtilizaNoitesGratis"
        label="A cada (Quantidade de noites)"
        type="number"
        placeholder="00"
        class="form--input"
        @blur="freeNightsInputHandler('diariasNoitesGratis')"
      />

      <!-- INPUT DE QUANTIDADE DE NOITES GRATIS -->
      <PmwFormInput
        v-model.number="fluctuationData.quantidadeNoitesGratis"
        :required="fluctuationData.utilizaNoitesGratis"
        :error="errors.includes('QuantidadeNoitesGratis') || hasErrors"
        data-error="QuantidadeNoitesGratis"
        label="Ganha (Quantidade de noites grátis)"
        type="number"
        placeholder="00"
        class="form--input form--input__larger"
        @blur="freeNightsInputHandler('quantidadeNoitesGratis')"
      />

      <!-- SELECT DE NOITES GRATIS -->
      <PmwFormSelect
        :value="freeNightsSelectValue"
        :options="freeNightsSelectOptions"
        :search="true"
        label="Quais serão as noites grátis"
        class="form--input__large"
        @input="freeNightsSelectHandler"
      />
    </div>
  </div>
</template>

<script>
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwInfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/PmwInfoTooltip'

export default {
  name: 'FreenNightsInputs',
  components: {
    PmwFormInput,
    PmwHeading,
    PmwFormSelect,
    PmwParagraph,
    PmwInfoTooltip
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /**
       * as primeiras / as ultimas / Mais baratas / Mais caras
       */
      freeNightsSelectOptions: [
        {
          text: 'As primeiras',
          value: 1
        },
        {
          text: 'As últimas',
          value: 2
        },
        {
          text: 'Mais caras',
          value: 3
        },
        {
          text: 'Mais baratas',
          value: 4
        }
      ],

      hasErrors: false
    }
  },

  computed: {
    freeNightsSelectValue() {
      return this.freeNightsSelectOptions.find(
        (item) => item.value === this.fluctuationData.tipoNoitesGratis
      )
    }
  },

  methods: {
    /** Verificador do handler de noites grátis
     * @param property - Propriedade do objeto principal a ser verificado
     */
    freeNightsInputHandler(property) {
      this.hasErrors = false

      if (
        this.fluctuationData.diariasNoitesGratis <=
        this.fluctuationData.quantidadeNoitesGratis
      ) {
        this.$bus.$emit('show-alert-chip', {
          message:
            'Quantidade de noites precisa ser maior que quantidade de noites grátis.'
        })

        this.fluctuationData[property] = null

        this.hasErrors = true
      }
    },

    freeNightsSelectHandler($event) {
      const { value } = $event

      this.fluctuationData.tipoNoitesGratis = +value
    }
  }
}
</script>

<style scoped lang="scss">
.free-nights-inputs {
  border: 1px solid pmw-colors(grey-20);
  padding: 12px 21px;

  .remove-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    &--btn {
      @include reset-button();

      .icon {
        width: 12px;
        height: 12px;
        color: $gray-dark;
        transition: color 0.8s;

        &:hover {
          color: red;
        }
      }
    }
  }
  .form {
    &--title {
      font-size: font-size('size-medium');
      font-weight: font-weight('weight-normal');
      color: pmw-colors(grey-90);
      line-height: 21px;
    }

    &--subtitle {
      font-size: font-size('size-small');
      font-weight: font-weight('weight-normal');
      color: pmw-colors(grey-80);
      line-height: 21px;
    }

    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 24px;
      margin-bottom: 18px;
    }

    &--input {
      width: 200px;

      &__large {
        width: 220px;

        ::v-deep {
          .pmw-form-field--label {
            font-weight: font-weight('weight-medium');
          }
        }
      }

      &__larger {
        width: 245px;
      }

      &__select {
        width: 435px;
        max-width: 435px;

        &.error {
          ::v-deep {
            .pmw-select--button {
              border-bottom-color: pmw-colors('error-100');
              border-bottom-width: 2px;
            }
          }
        }
      }

      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }
  }
}
</style>
